import axios from "axios";
import JWT from "expo-jwt";

export const get_access_token = async (user) => {
  const key = "6D502FF36314C8F20DCA065D976B6B73";
  const apiUrl = process.env.REACT_APP_API_URL;

  const now = Date.now();
  const payload = {
    iss: "C02C639DA5EFA656CA56E56A813869B5",
    sub: "9DAE91F4D392F688A5400990A71AA49D",
    exp: now + 6 * 9000,
    iat: now,
    user: user,
  };

  const auth = JWT.encode(payload, key, { algorithm: "HS256" });

  let data = {};
  data = await axios({
    method: "get",
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": auth,
    },
    withCredentials: false,
    url: `${apiUrl}/api/get_access_token`,
    
  });

  return data.data.access_token;
};
